
document.addEventListener('DOMContentLoaded', () => {
  const widgets = document.querySelectorAll('#shoppyc-clickcollect');
  widgets.forEach(widget => {
    // Remove all existing <style> tags
    widget.querySelectorAll('style').forEach(styleTag => {
      styleTag.remove();
    });
    // Observe future additions of <style> tags
    const observer = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        mutation.addedNodes.forEach(node => {
          if (node.tagName === 'STYLE') {
            node.remove();
          }
        });
      });
    });
    observer.observe(widget, { childList: true });
  });

  // For each tabs-section, handle tabs independently
  document.querySelectorAll('.tabs-section').forEach((section) => {
    const tabButtons = Array.from(section.querySelectorAll('.tab-button[data-tab-index]'));
    const tabContents = Array.from(section.querySelectorAll('.content'));
    const tabImages = Array.from(section.querySelectorAll('.tab-image'));

    const showTab = (index) => {
      tabContents.forEach(content => {
        content.style.display = 'none';
      });
      tabImages.forEach(image => {
        image.style.display = 'none';
      });
      tabButtons.forEach(button => {
        button.classList.remove('tab-button__selected');
        const heading = button.querySelector('h5');
        if (heading) heading.classList.remove('tab-button__selected');
      });
      const selectedContent = section.querySelector('.content[data-tab-index="' + index + '"]');
      if (selectedContent) selectedContent.style.display = 'block';
      const selectedImage = section.querySelector('.tab-image[data-tab-index="' + index + '"]');
      if (selectedImage) selectedImage.style.display = 'block';
      const selectedButton = section.querySelector('.tab-button[data-tab-index="' + index + '"]');
      if (selectedButton) {
        selectedButton.classList.add('tab-button__selected');
        const heading = selectedButton.querySelector('h5');
        if (heading) heading.classList.add('tab-button__selected');
      }
    };

    tabButtons.forEach((button) => {
      const index = button.getAttribute('data-tab-index');
      button.addEventListener('click', () => {
        if (index !== null) showTab(index);
      });
    });

    // Show the first tab actually rendered for this section
    if (tabButtons.length > 0) {
      const firstIndex = tabButtons[0].getAttribute('data-tab-index');
      showTab(firstIndex);
    }
  });
});
